import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout = () => {
    return (
        <>

            <section className="about_us pt_120 xs_pt_100 pb_120 xs_pb_100">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-5">
                            <div className="about_us_img wow fadeInLeft" style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                                <div className="text">
                                    <h3>5+</h3>
                                    <p>Years Experience 
                                        In Our Service</p>
                                </div>
                                <div className="img_1">
                                    <img src="assets/img/ChatGP.webp" alt="about" className="img-fluid" />
                                </div>
                                <div className="img_2">
                                    <img src="assets/img/ChatGPT (2).webp" alt="about" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-7">
                            <div className="about_us_text wow fadeInRight" style={{ visibility: 'visible', animationName: 'fadeInRight' }}>
                                <div className="section_heading left_heading mb_20">
                                    <h5>About Us</h5>
                                    <h2>About Sewax Services Private Limited</h2>
                                </div>
                                <p style={{textAlign:"justify"}}>Sewax Services Private Limited is a trusted multi-service company dedicated to delivering innovative, reliable, and customer-focused solutions across multiple industries. Guided by our motto, "One Company, Many Solutions," we provide a wide range of professional services designed to help individuals, businesses, and organizations achieve their goals with confidence.</p>
                                <div className="about_btn_area">
                                    <a style={{textTransform:"capitalize"}} className="common_btn" to="/about-us">Explore More<i className="far fa-long-arrow-right" aria-hidden="true" /></a>
                                    <ul className="d-flex flex-wrap align-items-center">
                                        {/* <li><img src="assets/images/small_img_1.png" alt="About" className="img-fluid" /></li> */}
                                        {/* <li><img src="assets/images/small_img_2.png" alt="About" className="img-fluid" /></li> */}
                                        {/* <li><img src="assets/images/small_img_3.png" alt="About" className="img-fluid" /></li> */}
                                        {/* <li><img src="assets/images/small_img_4.png" alt="About" className="img-fluid" /></li> */}
                                        {/* <li><img src="assets/images/small_img_5.png" alt="About" className="img-fluid" /></li> */}
                                    </ul>
                                    <h4>
                                        1500+
                                        <span>Happy Review</span>
                                    </h4>
                                </div>
                                <ul className="bottom_text">
                                    <li>
                                        <div className="icon">
                                            <img src="assets/images/about_icon_1.svg" alt="About" className="img-fluid" />
                                        </div>
                                        <h3>One Company for Multiple Professional Services</h3>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <img src="assets/images/about_icon_2.svg" alt="About" className="img-fluid" />
                                        </div>
                                        <h3>Experienced & Skilled Team</h3>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default HomeAbout